<template>
  <svg
    class="custom-icon"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6073_18934)">
      <rect width="40" height="40" rx="20" fill="white" />
      <g clip-path="url(#clip1_6073_18934)">
        <path
          d="M33.328 20.3092C33.328 19.3448 33.2414 18.4175 33.0807 17.5273H20.272V22.7943H27.5912C27.2698 24.4881 26.3054 25.9223 24.8589 26.8866V30.3113H29.2727C31.8443 27.9375 33.328 24.451 33.328 20.3092Z"
          fill="#4285F4"
        />
        <path
          d="M20.272 33.6003C23.944 33.6003 27.0226 32.3887 29.2727 30.3116L24.8589 26.8869C23.6473 27.7029 22.1018 28.1974 20.272 28.1974C16.736 28.1974 13.7316 25.8112 12.656 22.5967H8.13092V26.108C10.3687 30.5465 14.9556 33.6003 20.272 33.6003Z"
          fill="#34A853"
        />
        <path
          d="M12.656 22.5836C12.384 21.7676 12.2233 20.9021 12.2233 19.9996C12.2233 19.097 12.384 18.2316 12.656 17.4156V13.9043H8.13091C7.20363 15.7341 6.672 17.7988 6.672 19.9996C6.672 22.2003 7.20363 24.265 8.13091 26.0948L11.6545 23.3501L12.656 22.5836Z"
          fill="#FBBC05"
        />
        <path
          d="M20.272 11.8157C22.2749 11.8157 24.0553 12.508 25.4771 13.8433L29.3717 9.94875C27.0102 7.74803 23.944 6.40039 20.272 6.40039C14.9556 6.40039 10.3687 9.45421 8.13092 13.9051L12.656 17.4164C13.7316 14.2018 16.736 11.8157 20.272 11.8157Z"
          fill="#EA4335"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_6073_18934">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_6073_18934">
        <rect width="27.2" height="27.2" fill="white" transform="translate(6.40002 6.40039)" />
      </clipPath>
    </defs>
  </svg>
</template>
